// extracted by mini-css-extract-plugin
export default {"projectImages":"ProjectImages_projectImages__DkGQQ","projectImage":"ProjectImages_projectImage__ySyI3"};